import React, {Component} from 'react';
import './contact.scss';

import Header from '../../common/header';
import 'sweetalert2/src/sweetalert2.scss'
import "react-datepicker/dist/react-datepicker.css";
import MenuPresentation from '../menu-presentation';
import Session from "../../../sandbox/session";

class Contact extends  Component {

  constructor(props) {
    super(props);

    this.state = {
      step:1
    };
  }

  render() {

    return <body  className="body-content-view">

    <Header header={<h2 className={"title-page"}>ArtesaniasGb</h2>} store={false} />
    <div className="content">
      <div className={"content-men"}>
        <MenuPresentation active={3} />

      </div>
      <div className={"content-body"}>
        <h1>Contacto</h1>
        <article>
          <p>
            {Session.instance.country["contact"]}
          </p>
        </article>
      </div>
    </div>
    </body>
  }


}


export default Contact;
